import React from 'react';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { DepositType } from '@search/filter-enums/enums/DepositType';
import { CommissionType } from '@search/filter-enums/enums/CommissionType';
import { LivingTenantOption } from '@search/filter-enums/enums/LivingTenantOption';

import { RentConditionsFilter, LivingTenantOptionFilter } from '../../../../models/Filter';

interface IRentConditionButtonFilter {
    conditionFilter: RentConditionsFilter;
    tenantOptionFilter: LivingTenantOptionFilter;
    handleChange: (filter: RentConditionsFilter | LivingTenantOptionFilter) => void;
    isHouse?: boolean;
    classNameGroup?: string;
}

enum ConditionsType {
    utilitiesIncluded = 'utilitiesIncluded',
    noDeposit = 'noDeposit',
    noCommision = 'noCommision'
}

const CONDITIONS_TYPE: OptionType<ConditionsType>[] = [
    { label: 'Без залога', value: ConditionsType.noDeposit },
    { label: 'Без комиссии', value: ConditionsType.noCommision },
    { label: 'КУ включены', value: ConditionsType.utilitiesIncluded }
];

const LIVING_TENANT_TYPE_FLAT: OptionType<LivingTenantOption>[] = [
    { label: 'Можно с детьми ', value: LivingTenantOption.CHILDREN_ALLOWED },
    { label: 'Можно с животными ', value: LivingTenantOption.PETS_ALLOWED }
];

const LIVING_TENANT_TYPE_HOUSE: OptionType<LivingTenantOption>[] = [
    { label: 'Можно с животными ', value: LivingTenantOption.PETS_ALLOWED }
];

function getConditions(filter: RentConditionsFilter) {
    const res = [];

    if (filter.utilitiesIncluded) res.push(ConditionsType.utilitiesIncluded);
    if (filter.depositType === DepositType.NO_DEPOSIT) res.push(ConditionsType.noDeposit);
    if (filter.commisionType === CommissionType.NO_CLIENT_COMMISSION) res.push(ConditionsType.noCommision);

    return res;
}

export const RentConditionButtonFilterView: React.FC<IRentConditionButtonFilter> = ({
    conditionFilter,
    tenantOptionFilter,
    handleChange,
    isHouse = false,
    classNameGroup
}) => {
    const livingTenantType = isHouse ? LIVING_TENANT_TYPE_HOUSE : LIVING_TENANT_TYPE_FLAT;

    const onChangeCondition = React.useCallback((value: boolean, option: ConditionsType) => {
        const utilitiesIncludedType = conditionFilter.utilitiesIncluded;
        let depositType = conditionFilter.depositType;
        let commissionType = conditionFilter.commisionType;

        if (option === ConditionsType.utilitiesIncluded) {
            handleChange(new RentConditionsFilter(
                value,
                depositType,
                commissionType
            ));
        }

        if (option === ConditionsType.noDeposit) {
            depositType = value ? DepositType.NO_DEPOSIT : DepositType.UNKNOWN;
            handleChange(new RentConditionsFilter(
                utilitiesIncludedType,
                depositType,
                commissionType
            ));
        }

        if (option === ConditionsType.noCommision) {
            commissionType = value ? CommissionType.NO_CLIENT_COMMISSION : CommissionType.UNKNOWN;
            handleChange(new RentConditionsFilter(
                utilitiesIncludedType,
                depositType,
                commissionType
            ));
        }
    }, [
        handleChange,
        conditionFilter.commisionType,
        conditionFilter.depositType,
        conditionFilter.utilitiesIncluded
    ]);

    const onChangeLivingTenant = React.useCallback((value: boolean, option: LivingTenantOption) => {
        const options = new Set(tenantOptionFilter.livingTenantOptions);

        options[value ? 'add' : 'delete'](option);
        handleChange(new LivingTenantOptionFilter(Array.from(options)));
    }, [ handleChange, tenantOptionFilter.livingTenantOptions ]);

    return (
        <div className={classNameGroup}>
            {CONDITIONS_TYPE.map(type => (
                <div key={type.value} style={{ width: 'fit-content' }}>
                    <Checkbox
                        name={type.label}
                        onChange={value => onChangeCondition(value, type.value)}
                        value={getConditions(conditionFilter).includes(type.value)}
                        variant='filter'
                        block
                    >
                        {type.label}
                    </Checkbox>
                </div>
            ))}
            {livingTenantType.map(type => (
                <div key={type.value} style={{ width: 'fit-content' }}>
                    <Checkbox
                        name={type.label}
                        onChange={value => onChangeLivingTenant(value, type.value)}
                        value={tenantOptionFilter.livingTenantOptions.includes(type.value)}
                        variant='filter'
                        block
                    >
                        {type.label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
